import { Model } from '@vuex-orm/core';

export const timestamps = {
  created_at: Model.attr(null),
  updated_at: Model.attr(null),
};
